import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MainContent } from '@components';
import MenuSidebar from '@components/Sidebar/MenuSidebar';

export default function DefaultPage() {
  const [collapsed, setCollapsed] = useState(false);

  const handleMenuClick = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <div className="App">
        <MenuSidebar collapsed={collapsed} onClick={handleMenuClick} />
        <MainContent collapsed={collapsed}>
          <Outlet />
        </MainContent>
      </div>
    </>
  );
}
